import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import './ClientUserAccess.scss';
import { getClientUsers } from '$/store/client/actions';
import { AgGridReact } from 'ag-grid-react';
import { GridApi, ColumnApi, ICellRendererParams } from 'ag-grid-enterprise';

interface IClientUserAccessProps {
  client?: Bixby.Models.Client;
  users?: Bixby.Models.UserSlim[];
  dispatchGetClientUsers: () => Promise<void>;
}

const ClientUserAccess: React.FC<IClientUserAccessProps> = props => {
  const { client, users, dispatchGetClientUsers } = props;
  const [, setGridApi] = useState(null as GridApi | null);
  const [, setGridColumnApi] = useState(null as ColumnApi | null);

  useEffect(() => {
    const getClientUsersDispatcher = async () => {
      if (dispatchGetClientUsers) {
        await dispatchGetClientUsers();
      }
    };
    getClientUsersDispatcher();
  }, [dispatchGetClientUsers]);

  if (!client) {
    return null;
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const getContextMenuItems = () => {
    const result = ['copy', 'copyWithHeaders', 'separator', 'export'];
    return result;
  };

  if (client && !Bixby.Utils.isNullOrEmpty(users)) {
    return (
      <section className="client_UserAccess">
        <div className="user_access_data_grid">
          <div className="grid_container">
            <div className="grid ag-theme-alpine">
              <AgGridReact
                enableRangeSelection={true}
                getContextMenuItems={getContextMenuItems}
                defaultColDef={{
                  flex: 1,
                  minWidth: 100,
                  resizable: true,
                  lockPinned: true,
                  filter: 'agNumberColumnFilter',
                  cellClass: 'align-left',
                }}
                onGridReady={onGridReady}
                rowData={users}
                suppressDragLeaveHidesColumns={true}
                suppressMovableColumns={true}
                animateRows={true}
                rowHeight={32}
                headerHeight={32}
                columnDefs={[
                  {
                    field: 'email',
                    headerName: 'Email / Bixby User ID',
                    minWidth: 250,
                    cellRenderer: (params: ICellRendererParams) => {
                      return (
                        <Link className="link_underline bix-link" to={`/admin/user/${params.data['id']}`}>
                          {params.value}
                        </Link>
                      );
                    },
                  },
                  { field: 'firstName', headerName: 'First Name', minWidth: 250 },
                  { field: 'lastName', headerName: 'Last Name', minWidth: 250 },
                ]}></AgGridReact>
            </div>
          </div>
        </div>
      </section>
    );
  } else if (users && Bixby.Utils.isNullOrEmpty(users)) {
    return <p className="no_users">There are no users associated with {client.name}</p>;
  } else {
    return null;
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    dispatchGetClientUsers: () => dispatch(getClientUsers()),
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    client: state.clientState.currentClient,
    users: state.clientState.clientUsers,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ClientUserAccess);
